import React, { useState, useEffect } from "react";
import {
  Box,
  Stack,
  Typography,
  IconButton,
  TextField,
} from "@mui/material";
import { FormattedMessage } from "react-intl";
import CloseOutlined from "@ant-design/icons/CloseOutlined";
import ModalContainer from "components/ModalContainer";
import { OutlineButton } from "components/buttons/OutlineButton";
import { SolidButton } from "components/buttons/SolidButton";
import { SolidWarnButton } from "components/buttons/SolidWarnButton";
import DeleteViewModal from "./DeleteViewModal";

const EditViewModal = ({ open, view, onClose, onSave, onDelete }) => {
  const [viewName, setViewName] = useState("");
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);

  useEffect(() => {
    if (view) setViewName(view.name);
  }, [view]);

  const handleSave = () => {
    if (!viewName.trim()) return;
    onSave({ ...view, name: viewName.trim() });
    onClose();
  };

  const handleConfirmDelete = () => {
    onDelete(view.id);
    setShowDeleteConfirm(false);
    onClose();
  };

  return (
    <>
      <ModalContainer display={open} modalWidth="500px">
      <Stack spacing={3}>
        {/* Header */}
        <Stack direction="row" justifyContent="space-between" alignItems="center">
          <Typography sx={{ fontSize: "18px", fontWeight: "bold", color: "#172664" }}>
            <FormattedMessage id="edit-view" />
          </Typography>
          <IconButton onClick={onClose} sx={{ p: 0.5 }}>
            <CloseOutlined style={{ fontSize: "18px", color: "rgba(0,0,0,0.45)" }} />
          </IconButton>
        </Stack>

        {/* View Name */}
        <Stack direction="row" alignItems="center" spacing={2}>
          <Typography sx={{ width: 100, fontSize: "14px", color: "rgba(0,0,0,0.65)", flexShrink: 0 }}>
            <FormattedMessage id="view-name" />
          </Typography>
          <TextField
            fullWidth
            size="small"
            value={viewName}
            onChange={(e) => setViewName(e.target.value)}
            inputProps={{ maxLength: 50 }}
            sx={{
              "& .MuiOutlinedInput-root": {
                borderRadius: "8px",
                fontSize: "14px",
              },
            }}
          />
        </Stack>

        {/* Delete View */}
        <Stack direction="row" alignItems="center" spacing={2}>
          <Typography sx={{ width: 100, fontSize: "14px", color: "rgba(0,0,0,0.65)", flexShrink: 0 }}>
            <FormattedMessage id="delete-view" />
          </Typography>
          <SolidWarnButton width="100px" height="32px" onClick={() => setShowDeleteConfirm(true)}>
            <FormattedMessage id="delete" />
          </SolidWarnButton>
        </Stack>

        {/* Divider */}
        <Box sx={{ borderTop: "1px solid rgba(0,0,0,0.1)" }} />

        {/* Footer Buttons */}
        <Stack direction="row" justifyContent="center" spacing={2}>
          <OutlineButton width="100px" height="32px" onClick={onClose}>
            <FormattedMessage id="cancel" />
          </OutlineButton>
          <SolidButton width="100px" height="32px" onClick={handleSave}>
            <FormattedMessage id="save" />
          </SolidButton>
        </Stack>
      </Stack>
    </ModalContainer>

    <DeleteViewModal
      open={showDeleteConfirm}
      viewName={view?.name}
      onCancel={() => setShowDeleteConfirm(false)}
      onConfirm={handleConfirmDelete}
    />
    </>
  );
};

export default EditViewModal;
